import { render } from "./DropDownPage.vue?vue&type=template&id=5240e6b0&scoped=true"
import script from "./DropDownPage.vue?vue&type=script&lang=js"
export * from "./DropDownPage.vue?vue&type=script&lang=js"

import "./DropDownPage.vue?vue&type=style&index=0&id=5240e6b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5240e6b0"]])

export default __exports__